<template>
    <p class="stock-type__shipping">
        {{ shippingAddress.address_line_1 }}
        <br>
        <template v-if="shippingAddress.address_line_2">
            {{ shippingAddress.address_line_2 }}
            <br>
        </template>
        {{ shippingAddress.city }}, {{ shippingAddress.region }}, {{ shippingAddress.country }}
        <br>
        {{ shippingAddress.postal_code }}
    </p>
</template>

<script>
export default {
    props: {
        shippingAddress: {
            required: true,
            type: Object
        }
    }
}
</script>
